import {
  IonCol,
  IonGrid,
  IonRow,
  IonLabel,
  IonIcon
} from "@ionic/react";
import {
  assignDriverToShipment,
  inTransitData,
  loadAssignedData,
  loadCarrierData
} from "../../../actions/carrierAssign/action";
import { CarrierLoads } from "../../../models/home/CarrierAssignLoad.model";
import {
  IAssignShipmentToDriverV2InputProps
} from "../../../schemas/carrierAssign/CarrierAssign.schema";
import { IONICWrapper, GeographicalService, isEntitled } from "../../../utils/common";
import {
  LOAD_ASSIGN_FAIL,
  LOAD_ASSIGN_SUCCESS,
  MODULES,
  CityError,
  carrierProErrorLabelFallback,
  duplicateCarrierProError,
  TENDER_ACTION_DEFAULT_TIMEZONE,
  LO3_ASSIGN_DRIVER_HEADER_MESSAGE
} from "../../../utils/constants";
import { logEvent } from "../../../utils/Analytics";
import { EVENT, SCREEN } from "../../../utils/constants.analytics";
import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Persona } from "../persona/persona";
import "./ConfirmDriverDialog.scss";
import { LoadStop } from "../loadStops/loadStops";
import { ShipmentDetails } from "../shipment-details/shipmentDetails";
import { ToastMessage } from "../../../utils/ToastMessage";
import i18n from "../../../../i18n";
import { NewInput } from "../../../web/components/common/OriginInput";
import DatePicker from "react-datepicker";
import { getPredecessorShipmentStatus } from "../../../pages/Execute/CarrierAssigned/shipmentPage.util";
import { getCountryStateCodes } from "../../../actions/manage/action";
import { getOffSet } from "../../../selectors/Search/selector";
import { useTranslation } from "react-i18next";
import { CustomModalWeb } from "../../pages/userProfile/CustomModalWeb";
import { dayjs } from "../../../utils/Date/DateUtil";
import { isCarrierProVisible, startLocationAndTimeVisibility } from "../../../utils/sourceTMSAndDivisionFilter";
export interface IConfirmDriverDialogProps {
  open: boolean;
  driverDetails: any;
  userDetails: any;
  loadDetails: any;
  onDismiss: (cancel: boolean) => void;
  loadData: any;
  calculateTime: (stop: any) => string;
  count: any;
  module: string;
  predecessorShipmentDetails: any;
  isLo3User?: Boolean;
  header?: string;
  handleReloadPopup?:any;
  openReloadModal?:any;
}

export const ConfirmDriverDialog: React.FunctionComponent<IConfirmDriverDialogProps> = (
  props: IConfirmDriverDialogProps
) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const offSetValues = useSelector(getOffSet());
  const {
    driverDetails = {},
    loadDetails = {},
    open,
    onDismiss,
    userDetails = {},
    loadData = {},
    isLo3User = false,
    header,
    handleReloadPopup
  } = props;
  const [locationName, setLocationName] = useState<string>("");
  const [startDate, setStartDate] = useState<string | any>("");
  const [country, setCountry] = useState<string>("");
  const [postalCode, setPostalCode] = useState<string>("");
  const [isError, setisError] = useState<any>(false);
  const [timezoneOffset, setTimezoneOffset] = useState("");
  const [lat, setlat] = useState("");
  const [lng, setlng] = useState("");
  const [originError, setoriginError] = useState("");
  const [isCurrentLocationAvailable, setCurrentLocationStatus] = useState<
    boolean
  >(false);
  const [carrierPro, setCarrierPro] = useState(loadDetails?.carrierPro || "");
  const [carrierProError, setCarrierProError] = useState("");
  const [userInteraction, setUserInteraction] = useState(false);
  const ionModalRef = useRef<HTMLIonModalElement>(null);
  ionModalRef.current && ionModalRef.current.removeAttribute("tabindex");

  let loadStops: any[] = (loadDetails?.loadStop) || [];
  loadStops =
    loadStops.slice().sort((load1: any, load2: any) => {
      if (load1.sequenceNo && load2.sequenceNo) {
        return load1.sequenceNo - load2.sequenceNo;
      }
      if (load1.stopSequence && load2.stopSequence) {
        return load1.stopSequence - load2.stopSequence;
      }
      return 0;
    }) || [];

  const loadStopsToShow: any[] = [];

  loadStops.forEach((load: any, index: number) => {
    if (index == 0 || index == loadStops.length - 1) {
      loadStopsToShow.push(load);
    }
  });
  const dateTimeValue = loadStopsToShow[0]?.appointmentEarlyDateTime || loadStopsToShow[0]?.plannedArrivalDateTime;
  const dateTImeFormatCheck = setLocalZone(dateTimeValue?.substring(0, 16),dateTimeValue?.slice(-6));
  const dateTimeVisibilityCheck = startLocationAndTimeVisibility(loadDetails?.sourceTMS,loadDetails?.division,locationName,dateTImeFormatCheck) || null;
  const locationVisibilityCheck = startLocationAndTimeVisibility(loadDetails?.sourceTMS,loadDetails?.division,locationName,"") || null;

  const setErrorValue = (value: boolean, name: string) => {
    if (name === "locationName" && value === true) {
      setisError(CityError);
      setoriginError(CityError);
    } else if (name === "locationName" && value === false) {
      setisError("");
      setoriginError("");
    }
  };
  useEffect(()=>{
    if(!carrierPro && loadDetails?.carrierPro){
      setCarrierPro(loadDetails?.carrierPro)
    }
    setLocationName(locationVisibilityCheck);
    setStartDate(dateTimeVisibilityCheck);
  },[loadDetails])
  
  useEffect(() => {
    if (open) {
      const stateName =
        loadStopsToShow[0] &&
        `${loadStopsToShow[0].city}, ${loadStopsToShow[0].state}`;
      const actualStartDate =
        (loadStopsToShow[0] &&
          (loadStopsToShow[0].appointmentEarlyDateTime ||
            loadStopsToShow[0].plannedArrivalDateTime)) ||
        "";
        const responseTimeZone = loadStopsToShow[0]?.timeZone 
      const countryCode = loadStopsToShow[0]?.country;
      const postalCode = loadStopsToShow[0]?.postalCode;
      setLocationName(stateName || "");
      setisError(stateName ? "" : CityError);
      setStartDate(
        setLocalZone(
          actualStartDate.substring(0, 16),
          actualStartDate.slice(-6)
        )
      );
      !actualStartDate?.includes("Z") ? setTimezoneOffset(actualStartDate.slice(-6)) :setTimezoneOffset(getTimeZone(actualStartDate,responseTimeZone))
      setCountry(countryCode || "");
      setPostalCode(postalCode || "");
      loadDetails?.carrierPro ? setCarrierPro(loadDetails?.carrierPro) : setCarrierPro("");
    }
  }, [loadDetails.shipmentId,open]);

  const driverName =
    (driverDetails &&
      `${driverDetails.firstName || ""} ${driverDetails.lastName || ""}`) ||
    "";

  const dispatcherDetails = IONICWrapper.details.auth.user;

  /**
   * fetching the Lat Long values based on city, state and country.
   * * @param city: string, @param state: string, @param country: string
   * @returns object with Lat Long values.
   */
  const getLatlng = (city: string, state: string, countryName: string) => {
    const query = city + "," + state + "," + countryName;
    return new Promise(async function(resolve: any, reject: any) {
      await GeographicalService.details
        .searchAddress(query, async (addresses: any) => {
          if (
            addresses.length &&
            addresses[0]?.Address?.City.toLowerCase() === city.toLowerCase()
          ) {
            resolve(
              addresses[0].Coords
                ? { lat: addresses[0].Coords.Lat, lng: addresses[0].Coords.Lon }
                : {}
            );
          }
        })
        .catch((e: any) => {
          reject({});
        });
    });
  };
  const onConfirm = async () => {
    if (isError || carrierProError) return;
    const obj: CarrierLoads = new CarrierLoads();
    const _assignDriver: IAssignShipmentToDriverV2InputProps = {
      carrierId: driverDetails && driverDetails.carrierId,
      dispatcherName: `${userDetails?.memberDetailsResponse?.member?.firstName || ""} ${userDetails?.memberDetailsResponse?.member?.lastName ||
        ""}`,
      driverEmail: driverDetails?.email,
      driverId:
        driverDetails &&
        ((driverDetails?.userPrincipalName || driverDetails?.upn) || driverDetails.mobileNumber),
      driverName,
      driverPhone: driverDetails?.mobileNumber,
      shipmentId: loadDetails?.shipmentId,
      sourceSystem: loadDetails?.sourceTMS,
      tractorNumber: driverDetails?.tractorNumber,
      upn: dispatcherDetails.upn,
      messageTime: dayjs().format()
    };
    if(carrierPro !== loadDetails?.carrierPro){
      _assignDriver.carrierPro = carrierPro?.trim();
    }

    const location = locationName ? locationName.split(", ") : [];
    if (location.length === 1) {
      location.push("");
    }
    let startLocationData:any = {
      sourceSystem: loadDetails.sourceTMS,
      shipmentId: loadDetails.shipmentId,
      carrierId: userDetails?.memberDetailsResponse?.member?.carrierId,
      city: location[0],
      state: location[1],
      country,
      postalCode,
      positionDateTime: (setOtherZone(
        new Date(startDate),
        timezoneOffset
      )),
      startDateTime: (setOtherZone(
        new Date(startDate),
        timezoneOffset
      )),
      timeZone: ""
    };
    if (!userInteraction) {
      if(lat){
        startLocationData["latitude"] = lat.toString();
      }
      if(lng){
        startLocationData["longitude"] = lng.toString();
      };
    } else {
      let latLng: any;
      if (!lat && !lng) {
        latLng = (await getLatlng(location[0], location[1], country)) as any;
      }
      startLocationData = { ...startLocationData,
        latitude: lat
          ? lat.toString()
          : latLng && latLng.lat
            ? latLng.lat.toString()
            : "",
        longitude: lng
          ? lng.toString()
          : latLng && latLng.lng
            ? latLng.lng.toString()
            : "",
      };
    }
    if (
      getPredecessorShipmentStatus(loadDetails) ||
      !!(
        props.predecessorShipmentDetails &&
        props.predecessorShipmentDetails !== null
      )
    ) {
      dispatch(
        assignDriverToShipment(
          obj.assignShipmentToDriverV2(_assignDriver, null),
          onShowMessage
        )
      );
    } else {
      if (locationName && startDate && !isError) {
        dispatch(
          assignDriverToShipment(
            obj.assignShipmentToDriverV2(_assignDriver, startLocationData),
            onShowMessage
          )
        );
      }
    }
    if (
      !(
        offSetValues &&
        offSetValues.originDateDefaultOffset &&
        offSetValues.destinationDateDefaultOffset
      )
    ) {
      dispatch(getCountryStateCodes());
    }
  };

  const shipmentId = (loadDetails?.shipmentId) || "";

  const onShowMessage = (assignDriverToShipment: any, isError: boolean) => {
    if (!isError) {
      carrierPro && setCarrierPro("");
      const { shipment, message, status,successor } = assignDriverToShipment;
      let driverLoad: any[] = [];
      if (message && message.length && !status) {
        ToastMessage.showWeb(message);
        if(carrierPro){
        if(message.includes(carrierPro)){
          return setCarrierProError(duplicateCarrierProError);
        }
        }
        onDismiss(false);
        return;
      }
      if (shipment) {
        if (props.module === MODULES.CARRIER_ASSIGNED_MODULE) {
          if (loadData?.carrierLoad) {
            const carrierLoad: any[] = loadData.carrierLoad.filter(
              (item: any) => item.shipmentId !== shipment.shipmentId
            );
            dispatch(loadCarrierData(carrierLoad, carrierLoad.length));
          }
          driverLoad = loadData.driverLoad.concat([shipment]);
          dispatch(
            loadAssignedData(
              driverLoad,
              ((props.count?.driverAssignedCount) || 0) + 1
            )
          );
          props.loadDetails.history.push("/app/" + props.module, {
            shipments: [],
            module: props.module,
            shipmentId: null,
            callExistingAPI: false
          });
        } else if (props.module === MODULES.DRIVER_ASSIGNED_MODULE) {
          driverLoad = loadData.driverLoad.map((load: any) => {
            if (load.shipmentId === shipmentId) {
              return shipment;
            }
            return load;
          });
          dispatch(
            loadAssignedData(
              driverLoad,
              ((props.count?.driverAssignedCount) || 0) + 1
            )
          );
          props.loadDetails.history.push("/app/" + props.module, {
            shipments: shipment,
            module: props.module,
            shipmentId: null,
            callExistingAPI: false
          });
        } else if (props.module === MODULES.INTRANSIT_MODULE) {
          if (loadData && loadData.inTransitLoad) {
            const updatedShipment = loadData.inTransitLoad.map((load: any) => {
              if (load.shipmentId === shipmentId) {
                const updatedItem = {
                  ...shipment
                };
                return updatedItem;
              }
              return load;
            });
            dispatch(inTransitData(updatedShipment, updatedShipment.length));
          }
        } else if(isLo3User){
            handleReloadPopup && handleReloadPopup();
        }
        if(props?.loadDetails?.location?.state?.isBookLoad)
        {
          props.loadDetails.history.push("/app/" + props.module, {
            shipments: shipment,
            module: props.module,
            shipmentId: null,
            callExistingAPI: false
          });         
        }
      }
      if (status) {
        const success_message = LOAD_ASSIGN_SUCCESS.replace(
          "{{LOAD_ID}}",
          (shipment && shipment.shipmentId) || ""
        ).replace("{{DRIVER_NAME}}", driverName);
        ToastMessage.showWeb(success_message);
        (successor?.shipmentId === null || successor === null) && props.openReloadModal && props.openReloadModal();
      }
      // Analytics implementation
      logEvent(EVENT.UE_ASSIGN_DRIVER_SUCCESS, {
        screen: SCREEN.MYLOADS_DRIVER_ASSIGNMENT,
        carrierId: driverDetails && driverDetails.carrierId
      });
    } else {
      ToastMessage.showWeb(LOAD_ASSIGN_FAIL);
    }
    onDismiss(false);
  };

  const handleStartLocationChange = (event: any) => {
    const {
      target: { value, lat, lng, country, postalCode,timeZoneOffset }
    } = event;
    setLocationName(value);
    setlat(lat);
    setlng(lng);
    setCountry(country);
    setPostalCode(postalCode);
    timeZoneOffset && setTimezoneOffset(timeZoneOffset);
    if (!isCurrentLocationAvailable) {
      setCurrentLocationStatus(true);
    }
  };

  const predecessorMessageKeys =
    IONICWrapper.details.keys && IONICWrapper.details.keys.configuration;
    let confirmAssignmentProps;
    const AssignmentProps = {
      size: "large_cnfirmDriver",
      contentScroll: "deny",
      contentAlignment: "left",
    };
    if(isLo3User){
      confirmAssignmentProps = {
        ...AssignmentProps,
        title: IONICWrapper.details.keys.configuration.lO3AssignDriverHeaderMessage || LO3_ASSIGN_DRIVER_HEADER_MESSAGE,
        buttons: [
          {
            title: t("Confirm"),
            type: "primary-cta-btn-web",
            isDisabled: (getPredecessorShipmentStatus(loadDetails) || props.predecessorShipmentDetails !== null) ? false : !(startDate && locationName),
            onClick: () => onConfirm()
          }
        ]
      }
    } else {
      confirmAssignmentProps = {
        ...AssignmentProps,
        title: (
          predecessorMessageKeys.predecessorShipmentHeader ||
          i18n.t("predecessorShipmentHeader")
        )
          .replace("<shipment id>", loadDetails.shipmentId)
          .replace("<driver's first name>", driverName.split(" ")[0]),
        buttons: [
          {
            title: t("Cancel"),
            type: "secondary-cta-btn-web",
            onClick: () => {
              onDismiss(true);
              setCarrierPro("");
            }
          },
          {
            title: t("Confirm"),
            type: "primary-cta-btn-web",
            isDisabled: (getPredecessorShipmentStatus(loadDetails) || props.predecessorShipmentDetails !== null) ? false : !(startDate && locationName),
            onClick: () => onConfirm()
          }
        ]
      }
    }

  return (
    <React.Fragment>
      <CustomModalWeb
        isModalOpen={open}
        {...confirmAssignmentProps}
      >
        <div
          className={`confirm-driver-dialog  W-100 ion-margin ${
            getPredecessorShipmentStatus(loadDetails)
              ? "predecessorShipmentExist"
              : props.predecessorShipmentDetails &&
                props.predecessorShipmentDetails !== null
              ? "predecessorShipmentExist"
              : "predecessorShipmentNotExist"
          }`}
        >
          {getPredecessorShipmentStatus(loadDetails) ? (
            <IonRow color="dark">
              <IonCol size="8">
                <p className="predecessor-confirm-review">
                {predecessorMessageKeys.startLocationNotApplyForPredecessor ||
                  i18n.t("startLocationNotApplyForPredecessor")}
                </p>
              </IonCol>
              {isCarrierProVisible(loadDetails?.sourceTMS, loadDetails?.division) &&
                <IonCol size="4" className="carrier-pro-col">
                  <IonLabel className="carrier-pro-label">
                    Carrier PRO (Optional)
                  </IonLabel>
                  <input
                    type="text"
                    value={carrierPro}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                      if (loadDetails?.carrierPro && !e?.target?.value?.trim()) {
                        setCarrierProError(IONICWrapper?.details?.keys?.configuration?.carrierProErrorLabel || carrierProErrorLabelFallback);
                      } else {
                        carrierProError && setCarrierProError("")
                      }
                      setCarrierPro(e?.target?.value)
                    }}
                    placeholder="Enter Carrier PRO"
                    className={`carrierProInput ${!!carrierProError ? "error" : ""}`}
                  />
                  {!!carrierProError &&
                    <span className="carrierProErrorLabel">{carrierProError}</span>}
                </IonCol>
              }
            </IonRow>
          ) : props.predecessorShipmentDetails &&
            props.predecessorShipmentDetails !== null ? (
            <>
            <IonRow>
              <IonCol size="8">
                <p className="predecessor-confirm-review">
                  {predecessorMessageKeys.predecessorExistsMessage ||
                    i18n.t("predecessorExistsMessage")}
                </p>
                </IonCol>
                {isCarrierProVisible(loadDetails?.sourceTMS,loadDetails?.division) &&
                  <IonCol size="4" className="carrier-pro-col">
                        <IonLabel className="carrier-pro-label">
                          Carrier PRO (Optional)
                        </IonLabel>
                        <input
                          type="text"
                          value={carrierPro}
                          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            if (loadDetails?.carrierPro && !e?.target?.value?.trim()) {
                              setCarrierProError(IONICWrapper?.details?.keys?.configuration?.carrierProErrorLabel || carrierProErrorLabelFallback);
                            } else {
                              carrierProError && setCarrierProError("")
                            }
                            setCarrierPro(e?.target?.value)
                          }}
                          placeholder="Enter Carrier PRO"
                          className={`carrierProInput ${!!carrierProError ? "error" : ""}`}
                        />
                        {!!carrierProError &&
                          <span className="carrierProErrorLabel">{carrierProError}</span>}
                  </IonCol>
                }
              </IonRow>
            </>
          ) : (
            <>
              <IonRow>
                <IonLabel color="dark">
                  <p className="no-predecessor-confirm-review">
                    {predecessorMessageKeys.noPredecessorShipmentReviewMessage ||
                      i18n.t("noPredecessorShipmentReviewMessage")}
                  </p>
                </IonLabel>
              </IonRow>
              <IonRow>
                <IonCol size="4.4" className="confirm-location-col">
                  <IonLabel className="actual-start">
                    {i18n.t("predecessorStartLocation")}<div className="asterickRed">{"*"}</div>
                  </IonLabel>
                  <NewInput
                    Error={isError}
                    labelValue=""
                    InputValue={locationName}
                    InputName="locationName"
                    handleChange={(e: any) => handleStartLocationChange(e)}
                    isDestination={false}
                    deFaultValue={""}
                    locationValue={false}
                    useHandler={false}
                    setErrorValue={setErrorValue}
                    placeholder="Enter City Name"
                    onFocus={() => {
                      !userInteraction && setUserInteraction(true);
                      return setLocationName("")
                    }}
                    country={country}
                    postalCode={postalCode}
                  />
                </IonCol>
                <IonCol size="4.3" className="cnf-date-col">
                  <IonLabel className="actual-start">
                    {" "}
                    {i18n.t("predecessorActualTime")}<div className="asterickRed">{"*"}</div>
                  </IonLabel>
                  <DatePicker
                    onChange={(e: Date) => {
                      !userInteraction && setUserInteraction(true);
                      let value =
                        e === null
                          ? dayjs()
                              .format()
                              .toString()
                          : dayjs(e)
                              .format()
                              .toString();
                      setStartDate(getRoundOffTime(value));
                    }}
                    dateFormat="MMM d, yyyy hh:mm aa"
                    className="actual-start-date-time"
                    showTimeSelect
                    timeIntervals={5}
                    selected={(startDate && new Date(startDate)) || null}
                    placeholderText="Enter Start Date and Time"
                  />
                  <IonIcon
                    src="assets/icon/calender.svg"
                    className="predecessor-calander-icon calender-icon"
                  />
                </IonCol>
                {
                  isCarrierProVisible(loadDetails?.sourceTMS,loadDetails?.division) &&
                  <IonCol size="3.3" className="carrier-pro-col">
                        <IonLabel className="carrier-pro-label">
                          Carrier PRO (Optional)
                        </IonLabel>
                        <input
                          type="text"
                          value={carrierPro}
                          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            !userInteraction && setUserInteraction(true);
                            if (loadDetails?.carrierPro && !e?.target?.value?.trim()) {
                              setCarrierProError(IONICWrapper?.details?.keys?.configuration?.carrierProErrorLabel || carrierProErrorLabelFallback);
                            } else {
                              carrierProError && setCarrierProError("")
                            }
                            setCarrierPro(e?.target?.value)
                          }}
                          placeholder="Enter Carrier PRO"
                          className={`carrierProInput ${!!carrierProError ? "error" : ""}`}
                        />
                        {!!carrierProError &&
                          <span className="carrierProErrorLabel">{carrierProError}</span>}
                  </IonCol>
                }
              </IonRow>
            </>
          )}

          <IonRow>
            <IonCol size="12">
              <div className="load-stops-grid">
                <IonGrid className="confirm-dialog-load-grid">
                  <IonRow>
                    <IonCol size="3.5">
                      <ShipmentDetails
                        {...loadDetails}
                        loadId={loadDetails.shipmentId}
                        isCarrierLoad={true}
                        showLoadNo={false}
                      />
                    </IonCol>
                    <IonCol size="5.5">
                      <LoadStop
                        loadStops={loadStopsToShow}
                        calculateTime={props.calculateTime}
                      />
                    </IonCol>
                    <IonCol size="3" className="cnf-driver-persona-col">
                      <Persona
                        showName={true}
                        name={`${driverDetails.firstName} ${driverDetails.lastName}`}
                      />
                    </IonCol>
                  </IonRow>
                </IonGrid>
              </div>
            </IonCol>
          </IonRow>
        </div>
      </CustomModalWeb>
    </React.Fragment>
  );
};

const getRoundOffTime = (value: string): string => {
  let coeff = 1000 * 60 * 5;
  let date = new Date(); //or use any other date
  let rounded = new Date(Math.ceil(date.getTime() / coeff) * coeff);
  const timeString = rounded.toTimeString().slice(0, 8);
  value = value?.replace("00:00:00", timeString);
  return value;
};
const setLocalZone = (date: Date, timezone: string) => {
  const dateWithoutZone = dayjs.tz(date).format("YYYY-MM-DDTHH:mm");
  const localZone = dayjs(dateWithoutZone).format("Z");
  const dateWithLocalZone = [dateWithoutZone, localZone].join("");
  return dateWithLocalZone;
};
const setOtherZone = (date: Date, timezone: string) => {
  const dateWithoutZone = dayjs(date).format("YYYY-MM-DDTHH:mm");
  let finalTimezoneOffset = timezone.substr(0, 3).includes(":") ?
  timezone.substring(0, 1) + "0" + timezone.substring(1, timezone.length) 
      : timezone;
  const dateWithOtherZone = [dateWithoutZone, finalTimezoneOffset].join("");
  return dateWithOtherZone;
};

const getTimeZone =(date : string,timeZone :string)=>
{
  const defaultLocationTimeZone = timeZone? dayjs.tz(date.slice(0, 16).replace("T"," "),timeZone).format("Z") :
  dayjs.tz(date.slice(0, 16).replace("T"," "), TENDER_ACTION_DEFAULT_TIMEZONE).format("Z")
  return defaultLocationTimeZone 
}